import { assign } from 'lodash';

export function setItemInSessionStorage(key: string, value: any) {
    if (typeof value  === 'string') {
        sessionStorage.setItem(key, value);
    } else {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
}

export function getItemFromSessionStorage<Type>(key: string): Type | null {
    const value = sessionStorage.getItem(key);
    
    if (value) {
        try {
            return (JSON.parse(value) as Type);
        } catch (error) {
            return value as Type;
        }
    }
    
    return null;
}

export function getInstanceFromSessionStorage<Type>(key: string, type: { new (): Type }): Type | null {
    const instance = new type();
    return assign(instance, getItemFromSessionStorage(key));
}

export function removeItemFromSessionStorage(key: string) {
    sessionStorage.removeItem(key);
}

export function removeItensFromSessionStorage(keys: string[]) {
    keys.forEach(key => {
        removeItemFromSessionStorage(key);
    });
}

export const ROLES = 'roles';
export const ACCESS_TOKEN = 'access_token';
export const CREW_INFO = 'crew_info';
export const GOOGLE_USER = 'google_user';
export const FLIGHT_FORM_DATA='flight_form_data'
export const CHOOSE_FLIGHT_DATA='choose_flight_data';